import { ICreateIndicadorObraUseCase } from "../../../presentation/useCases/create/create_indicador_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateIndicadorObraUseCase
 */

export class CreateIndicadorObraUseCase implements ICreateIndicadorObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async createIndicadorObra(
    idObra: number,
    idIndicadores: number[],
  ): Promise<void> {
    if (idIndicadores.length === 0) throw Error('createIndicadorObra deve ter pelo menos um indicador');
    await this.repository.createIndicadorObra(idObra, idIndicadores);
  }
}
